import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { Building2, DollarSign, Calendar, TrendingUp } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../components/ui/card';
import { KPICard, DataTable, formatCurrency } from '../reportShared';

export default function HospitalAnalysisTab({ hospitalAnalysis }) {
  return (
    <div className="space-y-6" data-testid="reports-hospital-analysis-tab">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <KPICard title="Active Hospitals" value={hospitalAnalysis.length} icon={Building2} color="blue" />
        <KPICard
          title="Total Claims Value"
          value={formatCurrency(hospitalAnalysis.reduce((s, h) => s + h.total_amount, 0))}
          icon={DollarSign}
          color="green"
        />
        <KPICard
          title="Pending Amount"
          value={formatCurrency(hospitalAnalysis.reduce((s, h) => s + h.pending_amount, 0))}
          icon={Calendar}
          color="amber"
        />
        <KPICard
          title="Paid Amount"
          value={formatCurrency(hospitalAnalysis.reduce((s, h) => s + h.paid_amount, 0))}
          icon={TrendingUp}
          color="emerald"
        />
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="text-sm font-medium">Claims by Hospital</CardTitle>
        </CardHeader>
        <CardContent>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={hospitalAnalysis}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="hospital_name" tick={{ fontSize: 10, angle: -45, textAnchor: 'end' }} height={80} />
              <YAxis tick={{ fontSize: 10 }} />
              <Tooltip formatter={(value) => formatCurrency(value)} />
              <Legend />
              <Bar dataKey="pending_amount" fill="#f59e0b" name="Pending" stackId="a" />
              <Bar dataKey="paid_amount" fill="#10b981" name="Paid" stackId="a" />
            </BarChart>
          </ResponsiveContainer>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle className="text-sm font-medium">Hospital Claims Details</CardTitle>
        </CardHeader>
        <CardContent>
          <DataTable
            columns={[
              { key: 'hospital_name', header: 'Hospital' },
              { key: 'claim_count', header: 'Claims', align: 'center' },
              { key: 'total_amount', header: 'Total', align: 'right', render: (val) => formatCurrency(val) },
              { key: 'pending_amount', header: 'Pending', align: 'right', render: (val) => formatCurrency(val) },
              { key: 'paid_amount', header: 'Paid', align: 'right', render: (val) => formatCurrency(val) },
              { key: 'rejected_count', header: 'Rejected', align: 'center' }
            ]}
            data={hospitalAnalysis}
          />
        </CardContent>
      </Card>
    </div>
  );
}
